import { useDispatch, useSelector } from "react-redux";
import { ReactFormProvider as ReactFormProviderComponent } from "@7span/react-form";

import CommandAction from "@/components/command";
import Loader from "@/components/loader";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { RouterProvider } from "react-router-dom";
import { Toaster } from "ui/components/sonner";
import { checkAuthStatus } from "store/src/thunks/auth-thunks";
import routes from "@/router";
import { selectAuthStatus, selectUser } from "store/src/slices/auth-slice";
import { useEffect } from "react";
import ClarityAnalytics from "@/components/analytics/clarity";
import MaintenanceBreak from "@/modules/maintenance/maintenance-break";

export default function App() {
  const dispatch = useDispatch();
  const authStatus = useSelector(selectAuthStatus);

  const maintenanceEndDate = new Date("2026-03-23T12:00:00+05:30");
  const isMaintenanceMode = new Date() < maintenanceEndDate;

  useEffect(() => {
    dispatch(checkAuthStatus());
  }, [dispatch]);

  if (authStatus === "loading") {
    return <Loader />;
  }

  if (isMaintenanceMode) {
    return (
      <MaintenanceBreak
        targetDate={maintenanceEndDate}
        title="System Under Maintenance"
        message="We're performing scheduled maintenance to improve your experience. We'll be back online soon."
      />
    );
  }

  return (
    <div className="w-full min-h-screen ">
        <ReactFormProviderComponent
      isNewItemCheck={({ itemId }) => itemId === "create"}
      isArchivedItemCheck={(response) => response?.isArchived === true}
      errorAdapter={(error) => {
        return {
          name: error?.name || "Unknown Error",
          message:
            error?.message || "An unexpected error occurred. Please try again.",
          fieldErrors: error?.errors || {},
        };
      }}
    >
      <ClarityAnalytics />
      {/* <FrillWidget /> */}
      <RouterProvider router={routes} />
      {/* <ReactQueryDevtools initialIsOpen={false} /> */}
      <Toaster />
      </ReactFormProviderComponent>
    </div>
  );
}
